// Omnix/common/schemas/collections/omniInternalNotes.js
import { z } from "zod";

const OmniInternalNoteSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().describe("The subscription this note belongs to."),
    conversationId: z.string().describe("The conversation this note is attached to."),
    authorUserId: z.string().describe("The User ID of the user who wrote the note."),
    content: z.string().min(1, "Note content cannot be empty.").describe("The text of the note, may contain markdown and @mentions."),
    mentions: z.array(z.string()).optional().default([]).describe("An array of userIds mentioned in the note."),
    createdAt: z.coerce.date().optional(),
});

export default OmniInternalNoteSchema;